<template>
  <div class="uppercase text-white bg-pink-600 rounded-xl px-2 py-1 text-2sm flex justify-center items-center">
    <span>Bêta</span>
  </div>
</template>

<script>

export default {
    
};
</script>